module.exports = __webpack_public_path__ + "img/a1e6689c2f5b6e12688470e09fe0e2dc.jpg";